






















import { defineComponent, PropType, computed } from '@vue/composition-api';
import { isEmpty } from 'lodash-es';
import AdgroupLevelNode from './sidebar-node/adgroup-level-node.vue';
import CampaignNode from './sidebar-node/campaign-node.vue';
import { CampaignItem, AdgroupItem, AdItem } from './types';
import { CreationStep } from '@tt4b/ttam-enums';
// import ttamSidebarCopyCreativeDialog from './copy-creative-dialog.vue';
// import ttamSidebarCopyAdgroupDialog from './copy-adgroup-dialog.vue';
// import ttamSidebarDeleteDialog from './delete-dialog.vue';

const name = 'ttam-product-sales-11n-sidebar-compose';
export default defineComponent({
  name,
  components: {
    CampaignNode,
    AdgroupLevelNode,
    // ttamSidebarCopyCreativeDialog,
    // ttamSidebarCopyAdgroupDialog,
    // ttamSidebarDeleteDialog,
  },
  props: {
    curUid: {
      type: String,
      required: true,
    },
    curLevel: {
      type: String as PropType<CreationStep>,
      default: 'campaign',
    },
    campaignInfo: {
      type: Object as PropType<CampaignItem>,
      required: true,
    },
    adgroupInfos: {
      type: Array as PropType<AdgroupItem[]>,
      default: () => [],
    },
    splitTestInfo: {
      type: Object as PropType<AdgroupItem>,
      default: () => ({}),
    },
    adInfo: {
      type: Array as PropType<AdItem[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const adgroupLevelInfos = computed(() => {
      if (isEmpty(props.splitTestInfo)) {
        return props.adgroupInfos;
      }
      return props.adgroupInfos.concat(props.splitTestInfo);
    });
    function handleSwitch(level: CreationStep, uid: string) {
      emit('switch', level, uid);
    }

    function handleActionTrigger(level: CreationStep, eventName: string, uids) {
      console.log('==== action ====', level, eventName, uids);
      emit('action', level, eventName, uids);
    }

    function goToListPage(level: CreationStep, uuid: string) {
      emit('goToListPage', level, uuid);
    }
    return {
      name,
      adgroupLevelInfos,
      handleSwitch,
      handleActionTrigger,
      goToListPage,
    };
  },
});
